/* Lettoria NEVERMORE SALE (Wed 2026-10-07) — shared core: clock, formatters, cart add, hero countdown, sale phase,
 * schedule asset (fetched once, shared by the Lightning box + shelf Poe labels). Cloned from skullette-spooky-deal-core.js
 * (Spooky files stay frozen). Loaded first (defer); exposes window.LNM for lettoria-nevermore-lightning-deals.js,
 * lettoria-nevermore-evermore-shelf-grid.js, lettoria-nevermore-sticky-checkout-bar.js, lettoria-nevermore-quick-view-sheet.js.
 * Phases: pre (< sale open) → live (until 11:59:59 PM ET) → ended. Lightning window lives in the schedule asset.
 * QA clock: ?lnmnow=2026-10-07T14:30 (read as ET, -04:00) — the clock keeps ticking from that moment. */
(function () {
  var root = document.querySelector('[data-lnm]');
  if (!root) return;

  // ---- clock (optionally shifted for QA) ----
  var offset = 0;
  try {
    var q = new URLSearchParams(location.search).get('lnmnow');
    if (q) {
      var iso = /T\d\d:\d\d$/.test(q) ? q + ':00-04:00' : /[+-]\d\d:\d\d$|Z$/.test(q) ? q : q + '-04:00';
      var t = Date.parse(iso);
      if (!isNaN(t)) offset = t - Date.now();
    }
  } catch (e) { /* ignore bad override */ }
  function now() { return Date.now() + offset; }

  var START = Date.parse(root.dataset.start);
  var END = Date.parse(root.dataset.end);

  // ---- formatters ----
  function money(n) { return '$' + Number(n).toFixed(2); }
  function pct(price, compare) { return compare > price ? Math.round(100 - (100 * price) / compare) : 0; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function hms(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    return pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
  }
  function mmss(d) { var s = Math.max(0, Math.ceil(d / 1000)); return Math.floor(s / 60) + ':' + pad(s % 60); }
  var etFmt = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hour: 'numeric', minute: '2-digit' });
  // Every absolute time reads "11:59 PM ET (8:59 PM PDT your time)"; local part dropped when the visitor is on ET.
  var localFmt = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' });
  var localPlain = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit' });
  function whenLabel(ts) {
    var d = new Date(ts);
    var et = etFmt.format(d) + ' ET';
    return localPlain.format(d) === etFmt.format(d) ? et : et + ' (' + localFmt.format(d) + ' your time)';
  }
  function img(src, w) { return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function cleanTitle(t) { return String(t).replace(/\s*-?\s*(NEVER|EVER)MORE\s*DEAL\s*$/i, '').replace(/\s+/g, ' ').trim(); }
  // Pill labels: drop option parts shared by every variant, tidy the rest.
  // ["Premium Faux Leather", "Top-Grain Leather (Italian leather. Buttery-soft)"] → ["Faux Leather", "Top-Grain Leather"]
  // short=true also drops "Leather" → ["Faux", "Top-Grain"] (buttons, grid picker).
  function variantLabels(names, short) {
    var parts = names.map(function (n) { return String(n).split(/\s*\/\s*/); });
    return parts.map(function (ps) {
      var keep = ps.filter(function (x, i) {
        return parts.length < 2 || !parts.every(function (o) { return o[i] === x; });
      });
      return (keep.length ? keep : ps).map(function (x) {
        x = x.replace(/\s*\(.*?\)\s*/g, '').replace(/^Premium\s+/i, '').replace(/top[- ]grain/i, 'Top-Grain');
        return short ? x.replace(/\s+Leather$/i, '') : x;
      }).join(' · ');
    });
  }

  // ---- cart: Horizon module (window.LNMCart, opens drawer) → plain AJAX fallback ----
  // Resolves with the full cart (Horizon module) or null (fallback) so the sticky bar can repaint without a GET.
  function addToCart(variantId) {
    var items = [{ id: Number(variantId), quantity: 1 }];
    if (window.LNMCart) return window.LNMCart.add({ items: items });
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw new Error(j.description || 'Could not add to cart');
        return null;
      });
    });
  }

  // Photo flies from the button into the Horizon header cart icon. Visual confirmation while /cart/add.js runs
  // (all Nevermore/Evermore products are Simple Bundles → server add can take 1–2 s). Skipped under reduced motion.
  function flyToCart(src, fromEl) {
    if (!src || !fromEl || !fromEl.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var target = [].slice.call(document.querySelectorAll('.header-actions__cart-icon, #cart-bubble'))
      .filter(function (el) { return el.offsetParent !== null; })[0];
    if (!target) return;
    var a = fromEl.getBoundingClientRect(), b = target.getBoundingClientRect();
    var size = 72;
    var el = document.createElement('div');
    el.className = 'lnm-fly';
    el.style.backgroundImage = 'url("' + src + '")';
    el.style.left = (a.left + a.width / 2 - size / 2) + 'px';
    el.style.top = (a.top + a.height / 2 - size / 2) + 'px';
    document.body.appendChild(el);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    el.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.5 - 60) + 'px) scale(.7)', opacity: 1, offset: 0.5 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.15)', opacity: 0.4 }
    ], { duration: 650, easing: 'cubic-bezier(.4,0,.6,1)', fill: 'forwards' }).onfinish = function () { el.remove(); };
  }

  // Button feedback shared by Lightning + shelf + quick-view adds. Optimistic "Claimed ✓" + fly on tap; failure → "Sold out" / "Try again".
  // Fires 'lnm:added' on root with the cart (or null) so the sticky checkout bar repaints.
  // Returns a Promise<boolean ok> that settles once the final label ("Added ✓" / "Sold out" / "Try again") has been shown and the
  // button restored — the shelf picker waits on it so a failed add is never folded away before the shopper sees it.
  function runAdd(btn, variantId, src) {
    if (btn.disabled) return Promise.resolve();
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Claimed ✓';
    btn.classList.add('is-added');
    flyToCart(src, btn);
    var ok = false;
    return new Promise(function (settle) {
      var done = function (txt, ms) {
        btn.textContent = txt;
        setTimeout(function () { btn.textContent = label; btn.disabled = false; btn.classList.remove('is-added'); settle(ok); }, ms);
      };
      addToCart(variantId).then(function (cart) {
        ok = true;
        done('Claimed ✓', 1200);
        root.dispatchEvent(new CustomEvent('lnm:added', { detail: { cart: cart } }));
      }).catch(function (e) {
        btn.classList.remove('is-added');
        done(/sold out|not available|quantity|stock/i.test(e.message) ? 'Sold out' : 'Try again', 2200);
      });
    });
  }

  // ---- phase + hero countdown ----
  function phase() { var t = now(); return t < START ? 'pre' : t < END ? 'live' : 'ended'; }
  var clockEl = root.querySelector('[data-lnm-clock]');
  var clockLabel = root.querySelector('[data-lnm-clock-label]');
  var endedEl = root.querySelector('[data-lnm-ended]');
  var lastPhase = '';

  function tickHero() {
    var p = phase();
    if (p === 'pre') { clockLabel.textContent = 'Deals open in'; clockEl.textContent = hms(START - now()); }
    else if (p === 'live') { clockLabel.textContent = 'Sale ends in'; clockEl.textContent = hms(END - now()); }
    else { clockLabel.textContent = 'Sale has ended'; clockEl.textContent = ''; }
    if (p !== lastPhase) {
      lastPhase = p;
      root.classList.toggle('is-pre', p === 'pre');
      root.classList.toggle('is-ended', p === 'ended');
      if (endedEl) endedEl.hidden = p !== 'ended';
      root.dispatchEvent(new CustomEvent('lnm:phase', { detail: { phase: p } }));
    }
  }
  tickHero();
  setInterval(tickHero, 500);

  // [data-lnm-when="end"|"start"] → sale end (11:59 PM ET) / open time in ET + visitor's local time
  root.querySelectorAll('[data-lnm-when]').forEach(function (el) {
    el.textContent = whenLabel(el.dataset.lnmWhen === 'start' ? START : END - 60000);
  });

  // Jump links: Horizon hijacks window.scrollTo — scrollIntoView is reliable
  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-lnm-jump]');
    if (!a) return;
    var el = document.querySelector(a.getAttribute('href'));
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // Schedule asset (theme CDN, never bot.hc.tools): { start, lend, send, slot, p:[{h,t,img,v,vs,poe}], s:[productIndex per slot],
  // ep:[Evermore Poe handles] } — one fetch (started early by the section's inline warm-up), consumers attach .then/.catch.
  var schedule = window.__lnmSched || fetch(root.dataset.schedule)
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  schedule.catch(function () {}); // no unhandled rejection; Lightning shows its own retry message

  window.LNM = {
    root: root, schedule: schedule, now: now, START: START, END: END, phase: phase,
    money: money, pct: pct, hms: hms, mmss: mmss, whenLabel: whenLabel, img: img, esc: esc,
    cleanTitle: cleanTitle, variantLabels: variantLabels, runAdd: runAdd
  };
})();
